import { render } from "./DbsList.vue?vue&type=template&id=8dad9916"
import script from "./DbsList.vue?vue&type=script&lang=js"
export * from "./DbsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__